import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
// Faces before tokens: theme.css names these families in --font-display/--font-sans/
// --font-mono, so the @font-face rules have to be declared first.
import './styles/fonts.css'
import './styles/theme.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found in index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
